import { useApi } from './useApi';
import { url } from '../../utils/confserveur';

/**
 * L'adresse de « L'analyse de TanoEd » (route bilan-attendus du back) : la classe
 * ou le groupe ouvert, sur les 14 derniers jours. Le chef précise la matière.
 */
export const urlBilanAttendus = (id, { estGroupe = false, matiere = '' } = {}) => {
    const base = `${url}${estGroupe ? 'groupes' : 'classes'}/${id}/bilan-attendus/`;
    return matiere ? `${base}?matiere=${encodeURIComponent(matiere)}` : base;
};

/** `actif: false` (accès incomplet) : aucun appel. */
export const useBilanAttendus = (id, { estGroupe = false, matiere = '', actif = true } = {}) => useApi(
    urlBilanAttendus(id, { estGroupe, matiere }),
    null,
    undefined,
    id && actif ? undefined : 'not-enabled',
);
